import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@next/core-lib/i18n';

export interface QuestionnaireStep {
  labelKey: string;
  completed: boolean;
  disabled?: boolean;
}

@Component({
  selector: 'app-questionnaire-steps',
  imports: [TranslatePipe],
  templateUrl: './questionnaire-steps.component.html',
  styleUrl: './questionnaire-steps.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionnaireStepsComponent {
  readonly steps = input.required<readonly QuestionnaireStep[]>();
  readonly activeStep = input.required<number>();
  readonly stepSelected = output<number>();
}
